import {useCallback, useEffect, useState} from 'react';
import {useSelector} from 'react-redux';
import {getExportFields} from '../../../../api/EcaServices';
import {RootState} from '../../../../redux/store';
import {ecaExportResponseType} from '../../../eca-doc-list/eca-doc-list.util';

interface UseQueryExportFieldReturn {
  loading: boolean;
  fields: ecaExportResponseType[];
}

export const useQueryExportField = (): UseQueryExportFieldReturn => {
  const clientId = useSelector(
    (state: RootState) => state.selectedClient.clientId
  );
  const projectId = useSelector((state: RootState) => state.reports.projectId);

  const [state, setState] = useState({
    loading: false,
    fields: [],
  });

  const fetchExportFields = useCallback(() => {
    setState((prevState) => ({
      ...prevState,
      loading: true,
    }));

    const exportTypeParam = `exportType eq 'Review'`;
    const params = `clientId=${clientId}&projectId=${projectId}&filter=${exportTypeParam}&skip=0&top=5000`;

    getExportFields(params)
      .then((result) => {
        setState((prevState) => ({
          ...prevState,
          loading: false,
          fields: result?.data?.data ?? [],
        }));
      })
      .catch(() => {
        setState((prevState) => ({...prevState, loading: false}));
      });
  }, [clientId, projectId]);

  useEffect(() => {
    fetchExportFields();
  }, [fetchExportFields]);

  return {
    ...state,
    fields: (state.fields as ecaExportResponseType[])?.sort(
      (a: ecaExportResponseType, b: ecaExportResponseType) =>
        a.exportName.toLowerCase().localeCompare(b.exportName.toLowerCase())
    ),
  };
};
